import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ReactLoading from 'react-loading';
import './style.scss';

const Button = ({ title, className, onClick, isDisabled, isLoading }) => (
  <button
    className={cn(className, isDisabled ? 'btn-disabled' : '')}
    onClick={onClick}
    disabled={isDisabled || isLoading}
    type="button"
  >
    {isLoading ? <div className="loadingWrapper"><ReactLoading width={24} height={24} /></div> : title}
  </button>
);

Button.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
};

Button.defaultProps = {
  className: '',
  onClick: () => {},
  isDisabled: false,
  isLoading: false,
};

export default Button;
